import * as yup from 'yup';

import { requiredField } from './utils/messages';

export const createQRCodeValidation = yup.object({
  operationId: yup.number().nullable().required(requiredField),
  amount: yup.string().required(requiredField).typeError(requiredField),
});
